import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetConsultPreviewRefunds,
	GetConsultPreviewRefundsModel,
	GetConsultPreviewRefundsParams,
} from 'domain/usecases';

export class RemoteGetPreviewRefunds implements GetConsultPreviewRefunds {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetConsultPreviewRefundsModel>,
	) {}

	async get(params?: GetConsultPreviewRefundsParams): Promise<GetConsultPreviewRefundsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
